export default __webpack_public_path__ + "static/media/icon_user.05067cb2.svg";